import e from"react";const c=({children:c,className:a="col-sm-12"})=>e.createElement("div",{className:a},c);export{c as Col};
//# sourceMappingURL=Col.js.map
